export const checkManagerAuthorization = (featureID , currentUser) => {
    let authorize = false;
    if(currentUser && currentUser.Manager && currentUser.Manager.assignedFeatures.features.length > 0)
    {
        let feature = currentUser.Manager.assignedFeatures.features.find((fe) => {return fe == featureID})
        if(feature)
        {
            authorize = true;
        }
    }
   return authorize;       
}